import { render, staticRenderFns } from "./TherapyPtEditEntriesTable.vue?vue&type=template&id=78f6a63e&scoped=true&"
import script from "./TherapyPtEditEntriesTable.vue?vue&type=script&lang=js&"
export * from "./TherapyPtEditEntriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f6a63e",
  null
  
)

export default component.exports